module.exports = __webpack_public_path__ + "static/media/logo-triunfo.b1885f33.png";